(function (jQuery, Drupal, window) {

  Drupal.behaviors.image_resonsive = {

    attach: function (context) {
      const selector = '[data-component-id="nuplayer:image_responsive"]';
      addObserverToQuerySelectorElements(selector, (isVisible, element) => {
        if (isVisible) {
          jQuery(element).imagePick();
        }
      });
      once('image-responsive--processed', 'body', context).forEach(() => {
        jQuery(selector).imagePickAll();
        window.addEventListener("resize", () => {
          jQuery(selector).imagePickAll();
        });
      });
    },
  }

})(jQuery, Drupal, window);
